import classnames from 'classnames';

export const Header = (
    {
        notice,
        title,
        modeText,
        children,
        accountId = '',
        isConnected,
        mode
    }) => {
    return (
        <div className={'wc-stripe-header'}>
            <div className={'wc-stripe-header__row'}>
                <h1>
                    {title}
                </h1>
                <div className={'wc-stripe-header__account'}>
                    <span className={classnames('wc-stripe-header__account-status', {'connected': isConnected})}/>
                    <span>{isConnected ? accountId : notice}</span>
                    <span className={'wc-stripe-header__account-mode'}>{modeText}</span>
                </div>
            </div>
            <div className={'wc-stripe-header__row'}>
                {children}
            </div>
        </div>
    )
}

export default Header;